
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Page from "@/src/components/Page";
import DocShell from "@/src/layouts/DocShell";
import DocNavItem from "@/src/components/docs/DocNavItem";
import H1 from "@/src/components/docs/H1";
import CustomLink from "@/src/components/CustomLink";
import { IoRemoveOutline, IoEllipse } from "react-icons/io5";
import {
  Box,
  List,
  ListIcon,
  ListItem,
  Text,
  useColorMode,
} from "@chakra-ui/react";

const LegalNotice = () => {
  const { t } = useTranslation("legal");
  const { colorMode } = useColorMode();
  const isLight = colorMode === "light";

  const bodyColor = isLight ? "inherit" : "white";
  const headingColor = isLight ? "inherit" : "brand.600";

  const apdpRef = t("apdpRef");
  const sections = t("notice.sections", null, { returnObjects: true }) || [];

  const P = ({ children, ...rest }) => (
    <Text
      as={"p"}
      color={bodyColor}
      py={2}
      lineHeight={"1.6"}
      textAlign={"justify"}
      {...rest}
    >
      {children}
    </Text>
  );

  const Mail = ({ address }) => (
    <CustomLink to={`mailto:${address}`}>
      <Text as={"a"} color={"brand.500"}>
        {address}
      </Text>
    </CustomLink>
  );

  const Site = ({ href, label }) => (
    <CustomLink to={href}>
      <Text as={"a"} color={"brand.500"}>
        {label}
      </Text>
    </CustomLink>
  );

  const Article = ({ children }) => (
    <Box as={"article"} py={4} px={{ base: 2, md: 8, xl: 12 }}>
      {children}
    </Box>
  );

  return (
    <DocShell
      aside={
        <>
          {sections.map((title, i) => (
            <DocNavItem key={i} icon={IoRemoveOutline} to={String(i + 1)}>
              {title}
            </DocNavItem>
          ))}
        </>
      }
    >
      <Article>
        <H1 color={headingColor}>{t("notice.title")}</H1>
      </Article>

      {/* ── Déclaration à l'APDP ──────────────────────────────────────────── */}
      <Article>
        <H1 color={headingColor} id={"1"} py={4}>
          {sections[0]}
        </H1>
        <P>
          {t("notice.s1.p1a")} <b>{apdpRef}</b> {t("notice.s1.p1b")}{" "}
          <Site href={"https://www.watchman.bj"} label={"www.watchman.bj"} />.
        </P>
        <P>
          {t("notice.s1.p2a")}{" "}
          <Site href={"https://www.watchman.bj"} label={"www.watchman.bj"} />.{" "}
          {t("notice.s1.p2b")}
        </P>
        <P>{t("notice.s1.p3")}</P>
        <P>
          {t("notice.s1.p4a")}{" "}
          <Site href={"https://www.watchman.bj"} label={"www.watchman.bj"} />{" "}
          {t("notice.s1.p4b")}
        </P>
      </Article>

      {/* ── Droit d'accès ─────────────────────────────────────────────────── */}
      <Article>
        <H1 color={headingColor} id={"2"} py={8}>
          {sections[1]}
        </H1>
        <P>{t("notice.s2.intro")}</P>
        <List spacing={3} mt={4} ml={{ base: 3, lg: 6 }}>
          <ListItem color={bodyColor} lineHeight={"1.6"} textAlign={"justify"}>
            <ListIcon as={IoEllipse} color={"brand.500"} boxSize={2} />
            {t("notice.s2.post")}
          </ListItem>
          <ListItem color={bodyColor} lineHeight={"1.6"} textAlign={"justify"}>
            <ListIcon as={IoEllipse} color={"brand.500"} boxSize={2} />
            {t("notice.s2.emailLabel")}{" "}
            <Mail address={"support@watchman.bj"} />.
          </ListItem>
        </List>
        <P>{t("notice.s2.footer")}</P>
      </Article>

      {/* ── Confidentialité ───────────────────────────────────────────────── */}
      <Article>
        <H1 color={headingColor} id={"3"} py={8}>
          {sections[2]}
        </H1>
        <P>{t("notice.s3.p")}</P>
      </Article>

      {/* ── Propriété intellectuelle ──────────────────────────────────────── */}
      <Article>
        <H1 color={headingColor} id={"4"} py={8}>
          {sections[3]}
        </H1>
        <P>{t("notice.s4.p1")}</P>
        <P>{t("notice.s4.p2")}</P>
      </Article>

      {/* ── Conditions de service ─────────────────────────────────────────── */}
      <Article>
        <H1 color={headingColor} id={"5"} py={8}>
          {sections[4]}
        </H1>
        <P>
          {t("notice.s5.pa")}{" "}
          <Site
            href={"https://www.watchman.bj/"}
            label={"https://www.watchman.bj/"}
          />{" "}
          {t("notice.s5.pb")}
        </P>
      </Article>

      {/* ── Demande d'autorisation de reproduction ────────────────────────── */}
      <Article>
        <H1 color={headingColor} id={"6"} py={8}>
          {sections[5]}
        </H1>
        <P>
          {t("notice.s6.pa")}{" "}
          <Site
            href={"https://www.watchman.bj/"}
            label={"https://www.watchman.bj/"}
          />{" "}
          {t("notice.s6.pb")}
        </P>
      </Article>
    </DocShell>
  );
};

const LegalNoticePage = () => (
  <Page name="Legal Notice" path="/docs/legal-notice">
    <LegalNotice />
  </Page>
);

export default LegalNoticePage;


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/docs/legal-notice',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  